import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const FlagDobleImpresoraFormGroup = ({ iValue, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Col md={12}>
        <Field name='flagDobleImpresora'>
          {({ field }) => (
            <Form.Checkbox
              {...field}
              checked={iValue}
              disabled={fIsSubmitting}
              id='checkbox-flagDobleImpresora'
              label='Doble impresora'
            />
          )}
        </Field>
      </Col>
    </Form.Group>
  )
}

export default React.memo(FlagDobleImpresoraFormGroup)
